import { RetryPlugin } from '@module-federation/retry-plugin';
import type { ModuleFederationRuntimePlugin } from '@module-federation/enhanced/runtime';

const retryPlugin = (): ModuleFederationRuntimePlugin =>
	RetryPlugin({
		retryTimes: 5,
		retryDelay: 1500,
		// domains: ['http://localhost:2001'],
		// manifestDomains: ['http://localhost:2001'],
		addQuery: true,
		onRetry: ({ times, url }) => {
			if (navigator.onLine) {
				console.info('retry', times, url);
			} else {
				throw new Error(`Not Internet connection`);
			}
		},
		onError: ({ url }) => {
			throw new Error(`Failed load module ${url}`);
		},
	});
export default retryPlugin;
